/** The Mov library. One title today (Obsession), modelled so more slot in cleanly. */
export interface Movie {
  id: string;
  title: string;
  year: number;
  rating: string; // maturity, e.g. "18+"
  durationLabel: string;
  genres: string[];
  tagline: string;
  synopsis: string;
  hero: string; // wide backdrop (billboard)
  card: string; // landscape thumbnail (row)
  poster: string; // portrait
  accent: string; // dominant color pulled from the art, for glows
}

export const CATALOG: Movie[] = [
  {
    id: "obsession",
    title: "Obsession",
    year: 2026,
    rating: "18+",
    durationLabel: "1h 49m",
    genres: ["Thriller", "Drama", "Mystery"],
    tagline: "Some connections are impossible to let go.",
    synopsis:
      "A fleeting encounter in a dimly-lit bar becomes the fixation that unravels two lives. As attraction curdles into something darker, the line between desire and danger disappears — and neither of them can look away.",
    hero: "/art/obsession-hero.jpg",
    card: "/art/obsession-card.jpg",
    poster: "/art/obsession-poster.jpg",
    accent: "#c9483a",
  },
];

export const getMovie = (id: string | null | undefined): Movie | undefined =>
  CATALOG.find((m) => m.id === id);

/** A short, unguessable watch-party room id. */
export function newRoomId(): string {
  const bytes = new Uint8Array(8);
  (globalThis.crypto ?? { getRandomValues: (a: Uint8Array) => a }).getRandomValues?.(bytes);
  return Array.from(bytes, (b) => b.toString(36).padStart(2, "0")).join("").slice(0, 10);
}

/** The shareable link for a watch party. */
export function watchLink(roomId: string, movieId: string): string {
  return `${window.location.origin}${window.location.pathname}?room=${roomId}&movie=${encodeURIComponent(movieId)}`;
}
